import { DateTime } from 'luxon';

export const ANSWERED_SURVEY_MANAGE_WINDOW_HOURS = 30 * 24;
export const MANAGE_WINDOW_EXPIRED_ERROR = 'Answered surveys older than 30 days cannot be managed';

export function getAnsweredSurveyErrorMessage(error): string | undefined {
  const messages = error?.error?.errors?.[0]?.messages || [];
  return (messages.find((message) => message?.language?.code === 'en') || messages[0])?.text;
}

export function isAnsweredSurveyManageable(answeredDate: string): boolean {
  if (!answeredDate) return false;
  const answered = DateTime.fromSQL(answeredDate);
  if (!answered.isValid) return false;
  return answered >= DateTime.now().minus({ hours: ANSWERED_SURVEY_MANAGE_WINDOW_HOURS });
}
